<template>
    <button id="INFO" name="INFO" class="btn" data-vcode="INFO">
        <img src="/images/icons/info.svg" alt="" role="img" aria-hidden="true" />
        <label>{{ $t('infoButton') }}</label>
    </button>
</template>
<script>
export default {};
</script>
